<template>
    <MostaSelect
      :model-value="model"
      :options="options"
      @update:model-value="toggleOption"
    />
</template>

<script lang="ts">
/**
 * global segment selector
 */

import { CommonSelectorElement } from '@/models/interfaces/types.selector';
import { Component, Emit, Prop, Vue } from 'vue-facing-decorator';
import { AnalyticsV2ElementType, SelectorDataType } from '@/models/etc/types'
import MostaSelect from '@/components/common/MostaSelect.vue';

@Component({
  name: 'SegmentSelector',
  components: { MostaSelect }
})
export default class SegmentSelector extends Vue {
    private readonly storageSegmentIds = new Set<number>([
      AnalyticsV2ElementType.StorageItem,
      AnalyticsV2ElementType.StorageItemMovement,
    ]);

    @Prop({ default: [] as CommonSelectorElement[] })
    data!: CommonSelectorElement[]

    @Prop({ default: 0 })
    mode!: number

    @Prop({ default: SelectorDataType.List })
    dataType!: SelectorDataType;

    @Emit("change") changeModelIndex(arg: number) { return arg; }

    created() {
      this.changeModelIndex(this.model.value)
    }

    toggleOption(opt: any) {
        if (opt?.divider) { return }
        this.changeModelIndex(opt.value)
    }

    get model(): { label: string; value: number } {
        const found = this.options.find(
          (o: any) => !o.divider && o.value === (this.mode || 0)
        ) as { label: string; value: number } | undefined
        return found ?? { label: '', value: -1 }
    }

    get options() {
        if (!this.data) {
			return []
		}
        const toOption = (item: CommonSelectorElement) =>
          ({ label: this.$t(item.elementName), value: item.id })
        const regular = this.data
          .filter(item => !this.storageSegmentIds.has(item.id))
          .map(toOption)
        const storage = this.data
          .filter(item => this.storageSegmentIds.has(item.id))
          .map(toOption)

        if (!storage.length) {
          return regular
        }
        return [...regular, { divider: true }, ...storage]
    }

    get isList(): boolean {
        return this.data ? this.dataType === SelectorDataType.List : false
    }
}
</script>
